import type { Value } from '../../lib/workflows/types';
import { object, text } from '../../lib/workflows/repository';
import { Evidence } from './Evidence';
import { Table } from '../ui/Table';
export function DerivationPanel({
  value,
  title = 'Calculation derivation',
}: {
  value: Value;
  title?: string;
}) {
  const data = object(value),
    parameters = Array.isArray(data.parameters) ? data.parameters.map(object) : [];
  return (
    <section aria-label={title} className="rounded-field border border-border bg-muted/20 p-4">
      <h3 className="mb-3 text-label font-semibold">{title}</h3>
      {value === null ? (
        <p>Calculation evidence was not recorded for this legacy record.</p>
      ) : (
        <>
          <p className="text-label text-muted-foreground">
            Recorded inputs and versions used at calculation time.
          </p>
          {data.formula && <p className="my-3 break-words font-medium">{text(data.formula)}</p>}
          <Evidence value={data.inputs ?? value} name="recorded-inputs" depth={1} />
          {parameters.length > 0 && (
            <details className="mt-4">
              <summary className="cursor-pointer font-medium text-primary">
                Parameter versions ({parameters.length})
              </summary>
              <Table
                rows={parameters}
                getRowKey={(r) => `${text(r.kind)}:${text(r.key)}:${text(r.id)}`}
                columns={[
                  {
                    header: 'Parameter',
                    accessor: (r) => <span className="break-all">{text(r.key)}</span>,
                  },
                  {
                    header: 'Source',
                    accessor: (r) =>
                      r.kind === 'setting_default'
                        ? 'Definition default'
                        : text(r.kind).replaceAll('_', ' '),
                  },
                  {
                    header: 'Recorded value',
                    accessor: (r) => <Evidence value={r.value} depth={1} />,
                  },
                  {
                    header: 'Effective from',
                    accessor: (r) => text(r.effective_from) || 'Not versioned',
                  },
                  { header: 'Version', accessor: (r) => <Evidence value={r.id} name="id" /> },
                ]}
              />
            </details>
          )}
        </>
      )}
    </section>
  );
}
